import React from 'react';
import { useTranslation } from 'react-i18next';
import './HowItWorks.css';

const HowItWorks = () => {
  const { t } = useTranslation();
  
  const steps = [
    {
      number: '01',
      title: t('howItWorks.step1.title'),
      description: t('howItWorks.step1.description')
    },
    {
      number: '02',
      title: t('howItWorks.step2.title'),
      description: t('howItWorks.step2.description')
    },
    {
      number: '03',
      title: t('howItWorks.step3.title'),
      description: t('howItWorks.step3.description')
    },
    {
      number: '04',
      title: t('howItWorks.step4.title'),
      description: t('howItWorks.step4.description')
    }
  ];
  return (
    <section id="how-it-works" className="how-it-works">
      <div className="how-it-works__container">
        <div className="how-it-works__header">
          <span className="how-it-works__label">{t('howItWorks.label')}</span>
          <h2 className="how-it-works__title">{t('howItWorks.title')}</h2>
          <p className="how-it-works__subtitle">
            {t('howItWorks.subtitle')}
          </p>
        </div>
        
        <div className="how-it-works__steps">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step__number">{step.number}</div>
              <div className="step__content">
                <h3 className="step__title">{step.title}</h3>
                <p className="step__description">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step__connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(HowItWorks);
